import type { CSSProperties, ReactNode } from 'react';

/* indicador horizontal: um só componente para tudo que é % */
export function BarList({ items, stacked }: { items: Array<{ label: ReactNode; value: number }>; stacked?: boolean }) {
  return (
    <div className={stacked ? 'bars stacked' : 'bars'}>
      {items.map((b, i) => (
        <div className="bar" key={i}>
          <span className="l">{b.label}</span>
          <span className="t"><i style={{ '--v': `${Math.max(0, Math.min(100, b.value))}%` } as CSSProperties} /></span>
          <span className="n">{Math.round(b.value)}</span>
        </div>
      ))}
    </div>
  );
}
